import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { StorageService } from '@coin-depo-core/storage';

import type { CurrencyType, Currency } from '@coin-depo-types';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  currentCurrency: CurrencyType = this.storage.get('currency', 'USD');
  private currentCurrencySubject$ = new BehaviorSubject<CurrencyType>(
    this.currentCurrency
  );
  currentCurrency$ = this.currentCurrencySubject$.asObservable();

  constructor(private storage: StorageService) {}

  setCurrency(currency: CurrencyType) {
    this.currentCurrency = currency;
    this.storage.set('currency', this.currentCurrency);
    this.currentCurrencySubject$.next(currency);
  }

  getCurrencies(): Currency[] {
    return [
      { symbol: '$', code: 'USD' },
      { symbol: '&euro;', code: 'EUR' },
      { symbol: '&pound;', code: 'GBP' },
    ];
  }
}
